













import Vue, { PropType } from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';
import ResizeObserver from 'resize-observer-polyfill';

export default Vue.extend({
  props: {
    series: {
      type: Array as PropType<number[]>,
      default: [0],
    },
    labels: {
      type: Array as PropType<string[]>,
      default: [''],
    },
    colors: {
      type: Array as PropType<string[]>,
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.$refs.donutChart as HTMLDivElement);
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
  computed: {
    computedChartWidth(): string {
      return this.chartWidth + 'px';
    },
    computedChartHeight(): string {
      return this.chartHeight + 'px';
    },
    computedSeries(): number[] {
      return this.series.map((v) => +v);
    },
    chartOptions(): ApexOptions {
      return {
        labels: this.labels,
        colors: this.colors,
        dataLabels: {
          enabled: true,
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: '0%',
            },
          },
        },
        legend: {},
      };
    },
  },
  data(): {
    chartWidth: number;
    chartHeight: number;
    resizeObserver: ResizeObserver | null;
  } {
    return {
      chartWidth: 100,
      chartHeight: 100,
      resizeObserver: null,
    };
  },
  methods: {
    onResize() {
      const divElement = this.$refs.donutChart as HTMLDivElement;
      if (divElement) {
        this.chartWidth = Math.min(
          divElement.clientHeight * 1.6,
          divElement.clientWidth,
        );
        this.chartHeight = Math.min(divElement.clientHeight, this.chartWidth);
      }
    },
  },
});
